import React from 'react';
import { Images } from '../../assets';
import './styles.scss';
import { isMobile } from '../../utils';
import { Strings } from '../../constants';

type Props = {
  heading?: string;
  message?: string;
  subHeading?: string;
}

export const DownloadReccoScreen: React.FC<Props> = ({
  heading,
  message,
  subHeading,
}) => {
  return (
    <a
      href={process.env.REACT_APP_RECCO_PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="downloadRecco d-block text-decoration-none"
    ><div className='downloadRecco'>
      <img src={Images.GROUP_IMAGE} className="logo" alt="Recco Logo" />
      <div className='gap-1'>
        <p className='heading'>
          {heading}
        </p>
        <p className='subHeading'>
          {subHeading}
        </p>
        <p className='message'>
          {message}
        </p>
      </div>
      <button
        className={`btn btn-primary py-2 fw-bold button rounded-pill mb-4 ${isMobile() ? 'w-100' : ''} d-block`}
        style={{ backgroundColor: '#2E7CF6', border: 'none' }}
      >
        <a href={process.env.REACT_APP_RECCO_MARKETING_URL}>{Strings.DOWNLOAD_RECCO}</a>
      </button>
    </div></a>
  );
};
